<script setup lang="ts">
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import CSpin from '@lib/components/CSpin/CSpin.vue'

import useThemeVars from '@lib/composables/useThemeVars'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const themeVars = useThemeVars()

defineProps<{
  isLoading: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <div class="flex flex-col rounded-2 py-4 panel h-full items-center justify-center">
    <div class="flex justify-between px-4 mb-4 font-600 w-full">
      <div>
        {{ t('canvasUI.browserApp.panel.title') }}
      </div>
      <CButton circle @click="emit('close')">
        <CIcon fa-type="fas" icon="close" />
      </CButton>
    </div>

    <div class="flex flex-col w-full flex-1 px-4 overflow-auto">
      <CSpin v-if="isLoading" class="m-a" />
      <slot v-else />
    </div>
  </div>
</template>

<style scoped>
.panel {
  background-color: v-bind('themeVars.base');
}
</style>
